import { z } from 'zod';
import { BaseErrorSchema } from 'libs/end-to-end/src/types/errors/base-error-schema';

export const OrganizationContractAlreadyExistsError = BaseErrorSchema.extend({
  errorType: z.literal('OrganizationContractAlreadyExistsError'),
  id: z.string(),
});

export type OrganizationContractAlreadyExistsError = z.infer<
  typeof OrganizationContractAlreadyExistsError
>;
